import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';
import Constant from '../common/Constant';

const moment = require('moment');

const DEFAULT_STATE = Immutable({
  day: moment().format(Constant.DATE_FORMAT_SHORT),
  showMobileBlock: true,
  isInitialized: false,
  isUserLoading: false,
  isDeletingAccount: false,
  isWorkLogTodayLoading: false,
  isWorkLogTodayFailed: false,
  isProjectsLoading: false,
  isProjectsFailed: false,
  userError: '',
  deleteAccountError: '',
  activeMenuItem: 0,
  isSelectProject: false,
  isProjectUpdating: false,
  isAddProject: false,
  editProject: undefined,
  historyDetailsDate: undefined,
  dialog: undefined,
  notificationTitle: '',
  notificationOptions: {},
  addTimeProject: undefined,
  addTimeWorkLog: undefined,
  workLogsPerDayProject: undefined,
  workLogsPerDay: undefined,
  isWorkLogUpdating: false,
  timerProjectDetails: '',
  isAcceptingInvitation: false,
});

export default function(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case ActionTypes.DAY_CHANGED:
      return state.merge({
        day: action.day,
      });
    case ActionTypes.MOBILE_BLOCK_CONTINUE_CLICKED:
      return state.merge({
        showMobileBlock: action.showMobileBlock,
      });
    case ActionTypes.INITIALIZED:
      return state.merge({
        isInitialized: action.isInitialized,
      });
    case ActionTypes.USER_LOADING:
      return state.merge({
        isUserLoading: action.isUserLoading,
      });
    case ActionTypes.USER_ERROR:
      return state.merge({
        userError: action.error,
      });
    case ActionTypes.DELETING_ACCOUNT:
      return state.merge({
        isDeletingAccount: action.isDeletingAccount,
      });
    case ActionTypes.WORK_LOG_LOADING_TODAY:
      return state.merge({
        isWorkLogTodayLoading: action.isLoadingToday,
      });
    case ActionTypes.WORK_LOG_TODAY_FAILED:
      return state.merge({
        isWorkLogTodayFailed: action.isFailed,
      });
    case ActionTypes.PROJECTS_LOADING:
      return state.merge({
        isProjectsLoading: action.isProjectsLoading,
      });
    case ActionTypes.PROJECTS_FAILED:
      return state.merge({
        isProjectsFailed: action.isFailed,
      });
    case ActionTypes.DELETE_ACCOUNT_ERROR:
      return state.merge({
        deleteAccountError: action.error,
      });
    case ActionTypes.DASHBOARD_MENU_ITEM_CLICKED:
      return state.merge({
        activeMenuItem: action.index,
      });
    case ActionTypes.ACTIVITY_ADD_CLICKED:
      return state.merge({
        isSelectProject: action.isSelectProject,
      });
    case ActionTypes.PROJECT_UPDATING:
      return state.merge({
        isProjectUpdating: action.isProjectUpdating,
      });
    case ActionTypes.ADD_PROJECT_CLICKED:
      return state.merge({
        isAddProject: action.isAddProject,
      });
    case ActionTypes.EDIT_PROJECT_CLICKED:
      return state.merge({
        editProject: action.project,
      });
    case ActionTypes.HISTORY_DETAILS_CLICKED:
      return state.merge({
        historyDetailsDate: action.date,
      });
    case ActionTypes.SHOW_DIALOG:
      return state.merge({
        dialog: action.dialog,
      });
    case ActionTypes.SHOW_NOTIFICATION:
      return state.merge({
        notificationTitle: action.notification.title,
        notificationOptions: action.notification.options,
      });
    case ActionTypes.ACTIVITY_ADD_TIME_CLICKED:
      return state.merge({
        addTimeProject: action.data.project,
        addTimeWorkLog: action.data.workLog,
      });
    case ActionTypes.WORK_LOG_BLOCK_CLICKED:
      return state.merge({
        workLogsPerDayProject: action.data.project,
        workLogsPerDay: action.data.workLogs,
      });
    case ActionTypes.WORK_LOG_UPDATING:
      return state.merge({
        isWorkLogUpdating: action.isWorkLogUpdating,
      });
    case ActionTypes.TIMER_PROJECT_CLICKED:
      return state.merge({
        timerProjectDetails: action.projectId,
      });
    case ActionTypes.ACCEPTING_INVITATION:
      return state.merge({
        isAcceptingInvitation: action.isAcceptingInvitation,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/uiState.js